import ACCESS from 'utils/Access'
import store from 'containers/store'
import { map, filter, toPairs } from 'ramda'

const BILLING_PLAN_GATES = ['premium_enterprise', 'premium_team', 'premium_drift'] //descending order -- the former imply the latter

//little helper fn to turn {a: true, b: false} into [a]
const boolObjToArr = (boolObject) => map(pair => pair[0], filter(pair => !!pair[1], toPairs(boolObject)))

const getExactIdentifiers = () => {
  const user = store.getState().getIn(['currentUser', 'user'], {})
  return [
    `id${user.id}`,
    `orgId${user.orgId}`
  ]
}

const getRole = () => {
  if (ACCESS.isAdmin()) {
    return 'admin'
  } else if (ACCESS.isUser()) {
    return 'user'
  }
}

const getSize = (currentOrgUsers) => {
  const size = currentOrgUsers.size - 1 //subtract out the bot user
  let sizeGates = [`orgSize${size}`] //exact size
  //benchmarks
  if(size >= 2) {
    sizeGates.push('orgSizeGreaterOrEqual2')
  }
  if(size >= 5) {
    sizeGates.push('orgSizeGreaterOrEqual5')
  }
  if(size >= 10) {
    sizeGates.push('orgSizeGreaterOrEqual10')
  }
  if(size >= 20) {
    sizeGates.push('orgSizeGreaterOrEqual20')
  }
  return sizeGates
}

const getPlan = () => {
  const planGates = []

  for (const billingPlanGateIndex in BILLING_PLAN_GATES) {
    const gate = BILLING_PLAN_GATES[billingPlanGateIndex]
    if (ACCESS.hasGates(gate)) {
      planGates.push(gate)
      break
    }
  }

  if (planGates.length === 0) {
    planGates.push('free')
  }

  return planGates
}

export const getBeamerFilters = (currentOrgUsers, integrations) => {
  let filters = []
  filters = filters.concat(getExactIdentifiers()) //exact user/org ID
  filters = filters.concat(getRole()) //user vs admin
  filters = filters.concat(getSize(currentOrgUsers)) //number of users
  filters = filters.concat(getPlan()) //billing plan
  filters = filters.concat(boolObjToArr(integrations)) //all active integrations
  return filters
}



// WEBPACK FOOTER //
// ./src/scripts/utils/beamer.js